import React from "react";
import "./Footer.css";
import Footer_navLinks from "../Comman/Footer-nav";
import Footer_logo from "../../Aseets/Img/Footer_logo.svg";
import Social_icons from "../Comman/Social_icon";
import Facbook from "../../Aseets/Img/facebook.svg";
import Insta from "../../Aseets/Img/insta.svg";
import Linked_In from "../../Aseets/Img/linked in.svg";
import Twitter from "../../Aseets/Img/twitter.svg";

const Footer = () => {
  return (
    <footer>
      <div className="footer_div1">
        <div className="footer_div1_1">
            <div className="footer_div1_2">
                <h5 className="footer_title">QUICK LINKS</h5>
                <div className="footer_div1_3">
                 <ul className="footer_div2">
                 <Footer_navLinks  text="Exhibition" to="/" />
                <Footer_navLinks  text="Exhibitors" to="" /> 
                </ul>  
                 <ul className="footer_div2">
                 <Footer_navLinks  text="Booking" to="/" />
                <Footer_navLinks  text="Contact" to="" /> 
                </ul> 
                </div> 
            </div>
        </div>
        <img src={Footer_logo} alt="" />
              <div className="footer_div1_1">
            <div className="footer_div1_2">
                <h5 className="footer_title">CONTACT</h5>
                <div className="footer_div1_2"> 
                    <h5 className="footer_text1">contact@nebuexpo.com</h5>
                     <h5 className="footer_text1">+1 (555) 123-4567</h5>
                </div> 
            </div>
        </div>
      </div>
      <div className="divider"></div>
      <div className="footer_div4">
        <h6 className="footer_text">©2026 NEBU Gold & Jewelry Expo. All rights reserved.</h6>
        <div className="footer_div5">
          <h6 className="footer_text">Samia Ahmed</h6>
          <h6 className="footer_text">Designed by</h6>
        </div>
        <div className="footer_social_div">
            <Social_icons image={Facbook} />
            <Social_icons image={Insta} />
            <Social_icons image={Linked_In} />
            <Social_icons image={Twitter} />
        </div>
      </div>
    </footer>
  );
};

export default Footer;